<template>
    <div>
        <b-card> 
            <b-form>
                <div class="animated fadeIn">

                    <b-row>
                        <b-col md="12">
                        <b-form>
                            <b-form-group
                            description=""
                            label="Id do Modelo de Documento"
                            label-for="documentTemplateId"
                            :label-cols="3"
                            :horizontal="true">
                            <b-form-input v-model="documentTemplateId" id="documentTemplateId" type="number"></b-form-input>
                        </b-form-group> 
                        </b-form>
                        </b-col>
                    </b-row>
                </div>
            </b-form>

            <div slot="footer" class="text-right">
                <b-button variant="github" class="mr-1 btn-brand" @click="generatePdf()"><i class="fa fa-check"></i><span>Gerar PDF</span></b-button>
            </div>

        </b-card>

        <b-modal
            title="Documentos e Formulários" 
            class="modal-danger" 
            v-model="documentModal" 
            @ok="documentModal = false" 
            ok-variant="danger" 
            hide-footer size="xl" 
            v-if="selectedDocument"
        >
            <div class="ratio ratio-16x9">
                <iframe
                :src="this.selectedDocument"
                allowfullscreen
                width="100%"
                height="1000"
                ></iframe>
            </div>
        </b-modal>


    </div>
</template>


<script>
import Vue from 'vue'
import axios from "axios";


/* Toast */
import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */


export default {
    name: 'documentTemplatePdfComponent',
    props: {
       
    },
    components: {
       
    },
    data: () => {
        return {
            selectedDocument: null,
            documentModal: false,
            documentTemplateId: null
        }
    },
    methods: {
        async generatePdf() {

            var s = this;
            var currentUser = this.$store.state.currentUser;

            this.selectedDocument = this.$store.state.ws_url + "/document/template/pdf?documentTemplateId=" + this.documentTemplateId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            this.documentModal = true;


            /*
            console.log("Id: " + this.documentTemplateId)

            if(this.documentTemplateId && this.documentTemplateId > 0) {

                await axios.get(
                    this.$store.state.ws_url + "/document/template/pdf?documentTemplateId=" + this.documentTemplateId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
                ).then(function(resp) {
                    toast ({
                        type: VueNotifications.types.success,
                        title: 'Modelo de Documento',
                        message: 'Documento PDF gerado.',
                        timeout: 3000
                    })
                }).catch(function(error) {
                    toast ({
                        type: VueNotifications.types.error,
                        title: 'Modelo de Documento',
                        message: 'Erro ao gerar documento.',
                        timeout: 3000
                    })
                })

            }
            else {
                toast ({
                        type: VueNotifications.types.error,
                        title: 'Modelo de Documento',
                        message: 'Preencha o campo Id do Modelo de Documento.',
                        timeout: 3000
                    })
            }
            */
        }
    }
}
</script>